// `?seaProto=open|landlocked|rim` — DEV-only preview of the sea frame on a real
// game board (Phase 0 prototype). Read once at module load; default OFF, so
// normal play (and production builds, where the DEV guard is statically false)
// are byte-identical. `&seaWidth=1..5` sets the Open-sea ocean width.
//
// The sim board is unchanged: starts, pathing, the minimap and picking all
// still see the Rim board. See docs/sea-design.md Phase 0.

import {
  type SeaMode,
  extraOceanRings,
  frameForMode,
  parseSeaProto,
  parseSeaWidth,
} from './seaFrame.js';

export interface SeaProto {
  readonly mode: SeaMode;
  readonly width: number;
}

function read(): SeaProto | null {
  try {
    if (!import.meta.env?.DEV) return null;
    const mode = parseSeaProto(window.location.search);
    return mode ? { mode, width: parseSeaWidth(window.location.search) } : null;
  } catch {
    return null;
  }
}

let cached: SeaProto | null | undefined;

/** The active preview, or null. Evaluated once per page load. */
export function seaProto(): SeaProto | null {
  if (cached === undefined) cached = read();
  return cached;
}

/** Hex rings of sea drawn beyond the sim board (camera pan margin). */
export function protoSeaRings(proto: SeaProto | null): number {
  if (!proto) return 0;
  // Landlocked draws its mist curtain just past the rim: ~1 ring of slack.
  if (proto.mode === 'landlocked') return 1;
  return extraOceanRings(frameForMode(proto.mode, proto.width));
}
